import { useEffect, useState } from 'react';
import UAParser from 'ua-parser-js';

export interface UseMobileOs {
  userOs: 'Android' | 'Ios' | null;
}

export const useMobileOs = (): UseMobileOs => {
  const [userOs, setUserOs] = useState<'Android' | 'Ios' | null>(null);
  useEffect(() => {
    const parse = new UAParser();
    const os = parse.getOS();
    if (os.name === 'Android') {
      setUserOs(os.name);
    } else if (os.name === 'iOS') {
      setUserOs('Ios');
    }
  }, []);

  return { userOs };
};
